import React, { useEffect, useState, useContext } from 'react';
import './ImportData.scss';
import { withTranslation } from 'react-i18next';
import { Button } from 'react-bootstrap';
import ExpImpFilter from './ExpImpFilter';
import DownloadImg from "../../../images/file_5520239.png";
import KPIService from '../../../core/service/KPIService';
import { toast } from "react-toastify";
import { LoaderContext } from '../../../App';
import { LS_REGULATION_SELECTED_KEY } from '../../../core/constants/common';

const ExportFile = ({ t, type = 'ESG_REPORTING' }) => {

  const glbRegulationId = localStorage.getItem(LS_REGULATION_SELECTED_KEY);
  const [showFilter, setShowFilter] = useState(true);
  const [yearFilter, setYearFilter] = useState('');
  const [view, setView] = useState('DATA_VIEW');
  const [viewType, setViewType] = useState(type);
  const [viewLoader, setViewLoader] = useState(false);
  const { setLoaderDisplay } = useContext(LoaderContext);
  const [filter, setFilter] = useState({
    standardId: glbRegulationId,
    periodType: '',
    period: {},
    category: '',
    topicIds: [],
    parentBranchIds: [],
    childBranchIds: [],
    businessUnitIds: [],
  });
  const currentYear = new Date().getFullYear();

  const applyFilter = (f) => {
    setFilter(f);
    onExport(f);
  }

  const resetData = () => {

  }

  const onExport = (f) => {
    setLoaderDisplay(true);
    KPIService.downloadMetricDataTemplate(glbRegulationId, f.reportingPeriod, f.businessUnitIds, f.topicIds, f.categoryType)
      .then((response) => {
        setLoaderDisplay(false);
        let blob = new Blob([response.data], { type: 'application/octet-stream' });
        const fileURL = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = fileURL;
        link.download = `DataView-Template.xlsx`;
        link.click();
        link.remove();
        // setShowFilter(!showFilter);
      })
      .catch((error) => {
        setLoaderDisplay(false);
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  return (
    <div>
      <div className='Customize_templateView'>
        <div className='Customize_templateView_inner'>
          <img className='CT_DownloadImg' src={DownloadImg} />
          <h5>{t("ExportFileChooseTemplateText.label")}</h5>
          <p>{t("ExportFileNoteText.label")}</p>

          {/* <Button variant='primary' className={`px-3 ${showFilter ? 'd-none' : ''}`} onClick={() => setShowFilter(!showFilter)}>Download</Button> */}


          <div className={`ImportDownloadFilter ${showFilter ? '' : 'd-none'}`}>
            <ExpImpFilter
              view={view}
              dataViewType={viewType}
              onApplyFilter={(f) => applyFilter(f)}
              onResetFilter={() => resetData()}
              viewFilter={showFilter}
              onFilterHide={(value) => setShowFilter(value)} />
          </div>


        </div>
        {
          viewLoader &&
          <div className='Template_generated'>
            <div className='spinner-8 '></div>
            Template is being generated with the selected filters... Please wait.
          </div>
        }
      </div>


      {/* <div className='text-center p-2'>
        <Button variant='secondary' className='px-3 me-2'>Back</Button>
        <Button variant='primary' className='px-3' onClick={()=>onExport()}>Download</Button>
      </div> */}
    </div>
  );


};

export default withTranslation()(ExportFile);